import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Preloader } from '../preloader';
import { Console } from './../../services/platform-api';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { GetUser } from '../../services/platform-user';

const RecipeStartStop = (props) => {
  const [workatoId] = useSessionStorage('workatoId', '');
  const [userId] = useSessionStorage('userId', '');
  const userData = GetUser(userId);
  const [isPreloading, setIsPreloading] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    Console('recipe running: ', props.recipeStatus, 'log');

    setIsPreloading(true);

    let startstop = e.target.value === 'start' ? 'start' : 'stop';

    const StartStop = async () => {
      const payload = { url: `/api/managed_users/${workatoId}/recipes/${props.recipeID}/${startstop}` };

      await fetch(`/api/platform/proxy`, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json',
          'x-user-email': 'integrations@arcanum.ai',
          'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
        },
        body: JSON.stringify(payload),
      })
        .then((Response) => Response.json())
        .then((data) => {
          Console('data from button start stop', data);
          if (data.success !== true) {
          } else {
            Console('success preload off', data);

            setIsPreloading(false);
            props.setRecipeActive(!props.recipeStatus);

            // Trigger Slack Notification - Edd 10Mar23
            if (startstop === 'start') {
              let slackPayload = {
                Workato_id: workatoId,
                Recipe_id: props.recipeID,
                User_email: userData?.Email,
                Recipe_started: true,
              };
              fetch('https://www.workato.com/webhooks/rest/05793dc8-b885-4103-804a-17012c26efae/notify-slack', {
                method: 'POST',
                headers: {
                  'Content-type': 'application/json',
                },
                body: JSON.stringify(slackPayload),
              })
                .then(() => {
                  Console('Slack notify complete', '', 'log');
                })
                .catch((err) => {
                  console.error(err);
                });
            }
          }
        })
        .catch(console.error);
    };

    if (workatoId) StartStop();
  };

  if (isPreloading) return <Preloader />;

  return (
    <Button
      variant="primary"
      type="submit"
      disabled={props.recipeDisabled}
      value={props.recipeStatus ? 'stop' : 'start'}
      onClick={handleClick}
      className="mt-3 px-4"
    >
      {props.recipeStatus ? 'Stop Workflow' : props.recipeStatus === false ? 'Start Workflow' : 'Loading...'}
    </Button>
  );
};

export { RecipeStartStop };
